import React, {ReactNode, useEffect, useState} from 'react';
import {DetailGrid, Utility, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, WdiModalAppResult, WdiModalProps} from '@/components/WdiControls';
import {Button, Dropdown, Menu, message, Space} from 'antd';
import {initFieldDisplayFormater, TableColumnRanderFormats} from '@/components/WdiBus/TableColumnRanderFormats'
import DataStore from '@/components/GridWidget/DataStore'
import {ResponseStatus} from '@/utils/request';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import FormSADetailEditApp, {FormSADetailViewApp} from './detail-edit';
import FreeGoodsPickerApp from './detail-prev';
import {ImportModalApp} from '@/components/WdiControls/WdiImport';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {toExcel, ToExcelProps} from '@/components/WdiControls/WdiExcel';
import {ShipTo} from '@/services/mdm/shipto';
import {Product} from '@/services/mdm/product';
import {Position} from '@/services/basic/position';
import {FormSa, FormSaDetail} from '@/services/sales/sa';
import {FormApi} from "@/services/sales";

const ModalAppTypeEnums = {
  None: 0,
  Insert: 1,
  Edit: 2,
  Import: 3,
  Picker: 4,
  View: 5
};

export type DetailForApplyProps = {
  pid?: number | string | null,
  data?: {
    formSa?: API.FormSa,
    ecId?: Number,
  },
  dataSource: any[],
  onChange?: (dataSource: any) => void;
};

const FormSADetailsForApplyPanel: React.FC<DetailForApplyProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [importExcels, setImportExcels] = useState<ToExcelProps[]>([]);
  const {data, dataSource, onChange} = props;

  // //获取GridWdiget实例
  // const gridRef: any = useRef();

  const [editModalProps, setEditModalProps] = useState<WdiModalProps>({visible: false});
  const [importModalProps, setImportModalProps] = useState<WdiModalProps>({visible: false});

  const onImportClose = () => {
    setImportModalProps({visible: false, title: "", id: null});
  }
  const onImportSave = (uploadResult: any) => {
    if (uploadResult.code == ResponseStatus.SUCCESS) {
      const newDataSource = [...dataSource];
      const result = uploadResult?.data?.data;

      if (result && result.length > 0) {
        if (uploadResult?.data?.exProperty) {
          //是否清空
          onChange?.(DataStore.init(result));
        } else {
          onChange?.(DataStore.addMulti(newDataSource, result));
        }
      }
    }
    setImportModalProps({visible: false, title: "", id: null});
  }
  const onPrevClose = () => {
    setEditModalProps({visible: false, title: "", type: ModalAppTypeEnums.None, id: null});
  };
  const onPrevSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      setEditModalProps({
        visible: true, title: "新建申领明细", type: ModalAppTypeEnums.Insert, id: null,
        data: {
          rowIndex: -1,
          formSaDetail: result?.data,
          formSaDetails: dataSource,
          ecId: data?.ecId,
          formSa: {
            pageTypeId: data?.formSa?.pageTypeId,
            budgetProjectId: data?.formSa?.budgetProjectId,
            bohqId: data?.formSa?.bohqId
          }
        }
      });
    }
  };
  const onEditClose = () => {
    setEditModalProps({visible: false, title: "", type: ModalAppTypeEnums.None, id: null});
  };
  const onEditSave = (result?: WdiModalAppResult) => {
    if (result && result.code === ResponseStatus.SUCCESS) {
      const row = result?.data;

      if (editModalProps.type === ModalAppTypeEnums.Edit) {
        const record = editModalProps.data.formSaDetail;
        const newItem = {...row};
        newItem.uid = record.uid;
        const newDataSouce = DataStore.edit(dataSource, newItem);
        onChange?.(newDataSouce);
      } else if (editModalProps.type === ModalAppTypeEnums.Insert) {
        const newItem = {...row};
        onChange?.(DataStore.add(dataSource, newItem));
      }
    }
    setEditModalProps({visible: false, title: "", id: null});
  };

  const initImportExcel = () => {
    // 列包括产品编号，产品名称，V码规格编号，V码规格名称，销售小类编号，销售小类名称，销售大类编号，销售大类名称，品牌编号，品牌名称，
    // V码，规格编号，规格名称，主单位名称，包装1单位名称，包装1数量，包装2单位名称，包装2数量，净重，公司(多个拼起来，code-name)
    const productColumns = [
      {name: "productCode5", displayName: "产品编号"},
      {name: "productName5", displayName: "产品名称"},
      {name: "productCode4", displayName: "V码规格编号"},
      {name: "productName4", displayName: "V码规格名称"},
      {name: "productCode3", displayName: "销售小类编号"},
      {name: "productName3", displayName: "销售小类名称"},
      {name: "productCode2", displayName: "销售大类编号"},
      {name: "productName2", displayName: "销售大类名称"},
      {name: "productCode1", displayName: "品牌编号"},
      {name: "productName1", displayName: "品牌名称"},

      {name: "vCode", displayName: "V码"},
      {name: "specCode", displayName: "规格编号"},
      {name: "specName", displayName: "规格名称"},
      {name: "uom", displayName: "主单位名称"},
      {name: "uom1", displayName: "包装1单位名称"},
      {name: "uom1Quantity", displayName: "包装1数量"},
      {name: "uom2", displayName: "包装2单位名称"},
      {name: "uom2Quantity", displayName: "包装2数量"},
      {name: "weightNet", displayName: "净重"},
      {name: "companyCodeOrNames", displayName: "公司"},

    ];
    // 本BU的&激活的&（本人关联品牌下的 or 父级为空的）的产品，
    const productSheet = {
      dataLoading: async () => {
        return await Product.queryForSheet({
          isActive: true,
          productLevel: Enum.ProductLevel.PRODUCT5,
          withPermissions: true,
          withNullOrStaff: true,
        });
      },
      data: null,
      names: productColumns,
      sheetName: "产品",
    };
    // 收货地编号，收货地名称，客户编号，客户名称，四级使用部门（取shipto的boid）
    const shipToColumns = [
      {name: "shipToCode", displayName: "收货地编号"},
      {name: "shipToName", displayName: "收货地名称"},
      {name: "soldToCode", displayName: "客户编号"},
      {name: "soldToName", displayName: "客户名称"},
      {name: "boName", displayName: "四级使用部门"},
    ];
    const shipToSheet = {
      dataLoading: async (params: any) => {
        return await ShipTo.searchExcel({withPermissions: true});
      },
      data: null,
      names: shipToColumns,
      sheetName: "收货地",
    };
    const importExcels: ToExcelProps[] = [];
    importExcels.push({
      name: "全部下载",
      sheetProps: [productSheet, shipToSheet]
    });
    importExcels.push({
      name: "产品列表",
      sheetProps: [productSheet]
    });
    importExcels.push({
      name: "收货地列表",
      sheetProps: [shipToSheet]
    });
    setImportExcels(importExcels);
  }

  useEffect(() => {
    GridApi.searchConfig({id: 'FormSADetailsForFG', allowModifyColumns: false}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields)

      settings.formSchema.allFields.soldToCode.width = 200;
      settings.formSchema.allFields.shipToCode.width = 200;
      settings.formSchema.allFields.expectDeliveryDate.width = 150;
      settings.formSchema.allFields.expectArrivalDate.width = 150;

      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.amountDelivered.aggr = TableColumnRanderFormats.sumAggr('amountDelivered', 2);

      Utility.setActionCallback(
        settings.formSchema.actions,
        'Update',
        async (grid: any, action: any, record: any) => {
          const context = grid.getContext();
          setEditModalProps({
            visible: true,
            title: '编辑申领明细',
            type: ModalAppTypeEnums.Edit,
            id: record.formSaDetailId,
            data: {
              rowIndex: DataStore.getRowIndex(context.dataSource, record.uid),
              formSaDetail: record,
              formSaDetails: context.dataSource,
              ecId: context.params.ecId,
              formSa: {
                // formTypeId: data.formTypeId,
                pageTypeId: context.params.formSa.pageTypeId,
                budgetProjectId: context.params.formSa.budgetProjectId,
                bohqId: context.params.formSa.bohqId
              }
            }
          });
        },
      );

      Utility.setActionCallback(
        settings.formSchema.actions,
        'SystemDelete',
        async (grid: any, action: any, record: any) => {
          if (window.confirm("确定要删除此免费货申领信息吗？")) {
            const context = grid.getContext();
            onChange?.(DataStore.del(context.dataSource, record.uid));
            message.success("删除成功");
          }
        },
      );

      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.remark.width = 100;
      settings.formSchema.allFields.amount.width = 100;
      // settings.formSchema.allFields.deliveryDate.width = 120;

      initImportExcel();
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='免费货申领信息'/>}
      extra={
        <Dropdown.Button
          buttonsRender={(buttons: ReactNode[]) => {
            return [buttons[0], <Button type={"primary"} style={{width: 50, fontSize: 12}}>更多</Button>]
          }}
          type='primary'
          onClick={() => {
            setEditModalProps({
              visible: true,
              title: '选择客户',
              type: ModalAppTypeEnums.Picker,
              id: null,
              data: {
                formSaDetail: null,
                formSaDetails: dataSource,
                pageTypeId: data?.formSa?.pageTypeId,
                budgetProjectId: data?.formSa?.budgetProjectId
              }
            });
          }}
          overlay={
            <Menu items={[{
              key: 'import',
              label: '导入',
              onClick: () => {
                setImportModalProps({
                  title: '申领明细导入', visible: true
                });
                return true;
              }
            }]}/>
          }
          style={{float: 'right'}}
        >新建</Dropdown.Button>
      }
    >
      {isLoaded &&
        importModalProps.visible &&
        <ImportModalApp
          title={importModalProps.title}
          visible={importModalProps.visible}
          settingsUrl="/expenseapi/saButtons/getImportSettings"
          uploadingUrl="/expenseapi/saButtons/importUploading"
          onClose={onImportClose}
          onSave={onImportSave}
          clientParameters={{
            ecId: props.data?.ecId,
            formSa: data?.formSa,
            formSaDetails: JSON.stringify(dataSource)
          }}
          importExcels={importExcels}
        />
      }
      {isLoaded &&
        editModalProps.visible &&
        (editModalProps.type === ModalAppTypeEnums.Picker) &&
        <FreeGoodsPickerApp
          {...editModalProps}
          onClose={onPrevClose}
          onSave={onPrevSave}
        />
      }
      {
        isLoaded &&
        editModalProps.visible &&
        (editModalProps.type === ModalAppTypeEnums.Insert || editModalProps.type === ModalAppTypeEnums.Edit) &&
        <FormSADetailEditApp
          {...editModalProps}
          onClose={onEditClose}
          onSave={onEditSave}
        />
      }
      {
        isLoaded &&
        <DetailGrid {...pageGridSettings} params={data} autoColumn={['rowNumber']}/>
      }
    </WdiPanel>
  );
};
export default FormSADetailsForApplyPanel;

export const FormSADetailsForApprovalPanel: React.FC<DetailForApplyProps> = (props) => {
  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [dispModalProps, setDispModalProps] = useState<WdiModalProps>({visible: false});
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [form, setForm] = useState<API.Form>();

  const onClose = () => {
    setDispModalProps({visible: false, title: "", id: null});
  };

  //字段为 行号，活动明细编号，四级使用部门，客户，收货地，费用品牌，要求出库日期，要求到货日期，地址，发货完成，发货完成设置日期，发货完成设置人，备注，
  // 产品，领用单位，申领单价、申领数量，申领金额，发货数量，发货金额
  // 注：客户、收货地、品牌、产品分为编号名称两列，产品及后面的字段用FormGoodsDetail按sadetailid left join到sadetail上显示
  const exportButton = () => {
    return <Button
      type='primary'
      onMouseOver={() => setCollapsed(false)}
      onMouseOut={() => setCollapsed(true)}
      onClick={() => {
        const exportColumns = [
          {name: "rowNumber", displayName: "行号"},
          {name: "formSaDetailId", displayName: "活动明细编号"},
          {name: "boName", displayName: "四级使用部门"},
          {name: "soldToCode", displayName: "客户编号"},
          {name: "soldToName", displayName: "客户名称"},
          {name: "shipToCode", displayName: "收货地编号"},
          {name: "shipToName", displayName: "收货地名称"},
          {name: "brandCode", displayName: "费用品牌编号"},
          {name: "brandName", displayName: "费用品牌名称"},
          {name: "ecName", displayName: "费用项名称"},
          {
            name: "expectDeliveryDate",
            displayName: "要求出库日期",
            type: Enum.FieldType.DATE_TIME,
            format: 'yyyy-MM-dd'
          },
          {
            name: "expectArrivalDate",
            displayName: "要求到货日期",
            type: Enum.FieldType.DATE_TIME,
            format: 'yyyy-MM-dd'
          },
          {name: "address", displayName: "地址"},
          {name: "isDelivered", displayName: "发货完成", type: Enum.FieldType.BOOLEAN},
          {name: "deliveredSetupDate", displayName: "发货完成设置日期"},
          {name: "deliveredOperatorName", displayName: "发货完成设置人"},
          {name: "remark", displayName: "备注"},

          {name: "productCode", displayName: "产品编号"},
          {name: "productName", displayName: "产品名称"},
          {name: "ip", displayName: "IP"},
          {name: "uomName", displayName: "领用单位"},
          {name: "unitPrice", displayName: "申领单价"},
          {name: "quantity", displayName: "申领数量"},
          {name: "amount", displayName: "申领金额"},
          {name: "quantityDelivered", displayName: "发货数量"},
          {name: "amountDelivered", displayName: "发货金额"},
        ];
        dataSource.forEach((item: { startDate?: string; endDate?: string; }) => {
          if (wdiCore.String.IsNullOrEmpty(item.startDate)) {
            // @ts-ignore
            item.startDate = null;
          }
          if (wdiCore.String.IsNullOrEmpty(item.endDate)) {
            // @ts-ignore
            item.endDate = null;
          }
        })

        const innerSource: any[] = [];
        (dataSource ?? []).forEach((saItem: API.FormSaDetailVo) => {
          const saDetail: any = {
            rowNumber: saItem.rowNumber,
            formSaDetailId: saItem.formSaDetailId,
            boName: saItem.boName,
            soldToCode: saItem.soldToCode,
            soldToName: saItem.soldToName,
            shipToCode: saItem.shipToCode,
            shipToName: saItem.shipToName,
            brandCode: saItem.brandCode,
            brandName: saItem.brandName,
            ecName: saItem.ecName,
            expectDeliveryDate: saItem.expectDeliveryDate,
            expectArrivalDate: saItem.expectArrivalDate,
            address: saItem.address,
            isDelivered: saItem.isDelivered,
            deliveredSetupDate: saItem.deliveredSetupDate,
            deliveredOperatorName: saItem.deliveredOperatorName,
            remark: saItem.remark,
          };
          (saItem?.formGoodsDetails ?? []).forEach((fgItem: API.FormGoodsDetailVo) => {
            innerSource.push(Object.assign({...saDetail}, fgItem))
          })
        })

        const saDetailSheet = {
          data: innerSource,
          names: exportColumns,
          sheetName: "免费货申领明细",
          cells: {
            quantity: (fieldObject: any, row: any, value: any) => {
              return wdiCore.Number.ToNumber(row.quantity, 5)
            },
          }
        };
        toExcel({
          name: form?.formNo + "_" + wdiCore.Date.ToString(new Date()) + ".xlsx",
          sheetProps: [saDetailSheet]
        })
      }} style={{float: 'right', marginRight: 10}}>
      导出
    </Button>
  }


  useEffect(() => {
    if (!props.pid) {
      return;
    }
    Promise.all([GridApi.searchConfig({id: 'FormSADetailsForFGApproval', allowModifyColumns: true}),
      Position.access({useCaseId: Enum.UseCase.SA, operateTypeIds: [Enum.OperateType.COMPLETE_DELIVERY]}),
      FormSa.get(props.pid ? Number(props.pid) : 0),
      FormApi.get(props.pid ? Number(props.pid) : 0)
    ]).then((dataArray: any[]) => {
      const response = dataArray[0];
      const allowCompleteDelivery = dataArray[1].data;
      const formSa = dataArray[2].data;
      setForm(dataArray[3].data)
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.Left,
        showAggr: true,
        filterMenuActions: (actions: any, record: any) => {
          const newActions: any[] = [];
          actions.forEach((item: any) => {
            if (item.name == 'ViewGoodsDetail') {
              newActions.push(item);
            }
            if (item.name == 'CompleteDelivery'
              && formSa.statusId == Enum.FormStatus.APPROVE_COMPLETED
              && allowCompleteDelivery
              && !record.isDelivered
            ) {
              newActions.push(item);
            }
          });
          return newActions;
        }
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.amount.aggr = TableColumnRanderFormats.sumAggr('amount', 2);
      settings.formSchema.allFields.amountDelivered.aggr = TableColumnRanderFormats.sumAggr('amountDelivered', 2);
      settings.formSchema.allFields.rowNumber.width = 70;
      settings.formSchema.allFields.soldToCode.width = 200;
      settings.formSchema.allFields.shipToCode.width = 200;
      settings.formSchema.allFields.amount.width = 100;
      settings.formSchema.allFields.isDelivered.width = 100;
      settings.formSchema.allFields.amountDelivered.width = 100;

      Utility.setActionCallback(
        settings.formSchema.actions,
        'ViewGoodsDetail',
        async (grid: any, action: any, record: any) => {
          setDispModalProps({
            visible: true,
            title: '免费货申领明细信息',
            type: ModalAppTypeEnums.Edit,
            id: record.formSaDetailId,
            data: record
          });
        },
      );

      if (allowCompleteDelivery) {
        Utility.setActionCallback(settings.formSchema.actions,
          'CompleteDelivery',
          (grid: any, action: any, record: any) => {
            if (window.confirm("确定要设置发货完成？")) {
              const args: API.ButtonArgs = {
                formId: record.formSaId,
                key: "CompleteDelivery",
                items: [{name: "formSaDetailId", value: String(record.formSaDetailId)}]
              }
              FormSa.Buttons.completeDelivery(args).then(responseresult => {
                if (responseresult.code == ResponseStatus.SUCCESS) {
                  message.success('操作成功!');
                  FormSaDetail.getFgEx(Number(props.pid)).then((response) => {
                    if (props.onChange) {
                      props?.onChange(response.data);
                    }
                  });
                } else {
                  message.error(responseresult.message);
                }

              })
            }
          });
      }

      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, [props.pid]);

  const {dataSource} = props;
  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    pagination: {
      defaultPageSize: 10,
      showSizeChanger: true
    },
    dataSource
  };

  return (
    <WdiPanel
      title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='免费货申领信息'/>}
      collapsed={collapsed}
      extra={
        <Space>
          {exportButton()}
        </Space>
      }
    >
      {isLoaded && <DetailGrid {...pageGridSettings} />}
      {
        isLoaded &&
        dispModalProps.visible &&
        <FormSADetailViewApp
          {...dispModalProps}
          onClose={onClose}
          form={form}
        />
      }
    </WdiPanel>
  );
};

